import { tryLoadLightDOMStyles } from '@/components/webcomponents/Global/loadDependency'
import { getTemplateNavFooterLevel0LinksStyles } from './NavFooterLevel0Links.styles'

const t = document.createElement('template')
t.innerHTML = `
<div name="footer-links" class="ascend-footer__list" role="list">
  <slot></slot>
</div>
`
const TemplateNavFooterLevel0Links = t

class NavFooterLevel0Links extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavFooterLevel0LinksStyles().content.cloneNode(true))
    shadow.appendChild(TemplateNavFooterLevel0Links.content.cloneNode(true))

    tryLoadLightDOMStyles('NavFooterLevel0Links.css')
  }

  connectedCallback() {
    console.log('NavFooterLevel0Links connectedCallback')
  }
}

if (!customElements.get('ts-navfooter-level0-links')) {
  customElements.define('ts-navfooter-level0-links', NavFooterLevel0Links)
}
export { NavFooterLevel0Links }
